<div class="container my-4">
    <div class="row">
        <div class="col-12 commission_report">
            <div class="title_header_bar">
                Recovery Fee Workout
            </div>
        </div>
    </div>
    <div class="card card_content" [formGroup]="recoveryFeeForm">
        <div class="row mb-3">
            <div class="col-xl-3 d-none d-md-block">
            </div>

            <div class="col-md-4 padd-right-file" style="display: flex;">
                <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
                  <mat-label>Search</mat-label>
                  <div class="search-input-container">
                    <input placeholder="Enter Customer Reference     Number" id="search" matInput
                      (keyup)="checkifenter($event)" type="text" #searchInput  formControlName="searchtxt">
                  </div>
                </mat-form-field>
                <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
                  (click)="search()">
                  <mat-icon style="color: white;">search</mat-icon>
                </button>
              </div>

            <div class="col-xl-3" style="align-self: end;">
                <!-- <button class="btn btn-secondary " (click)="refresh()">
                    <i class="fa fa-refresh"></i> Refresh
                </button> -->
                <app-button (refreshClicked)="refresh()"></app-button>

            </div>
        </div>
        <hr *ngIf="showConnectionList">
        <div class="row mt-3" *ngIf="showConnectionList">
            <div class="col-md-3"></div>
            <div class="col-md-6 text-center">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>Connection</mat-label>
                    <mat-select class="scrollbarcs" formControlName="selectedConnectionDetails"
                        placeholder="Select Service Change Number" (selectionChange)="connectionOnChange()">
                        <mat-select-filter [displayMember]="'value'" [array]="terminateFeeList"
                            (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                        <mat-option *ngFor="let item of filteredList1" [value]="item.serviceChangeReferenceNumber"
                            style="overflow-y: scroll !important;">
                            {{item.serviceChangeReferenceNumber}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-md-3"></div>
        </div>
        <hr  *ngIf="showConnectionList">

        <div class="mx-3" *ngIf="terminateFee">
            <div class="row mt-3">
                <div class="col-xl-6">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Customer Number</mat-label>
                        <div class="search-input-container">
                            <input placeholder="Enter Customer  Number" id="search" matInput type="text"
                                formControlName="referenceNumber">
                        </div>
                    </mat-form-field>
                </div>
                <div class="col-xl-6">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Customer Name</mat-label>
                        <div class="search-input-container">
                            <input placeholder="Enter fullName" id="search" matInput type="text"
                                formControlName="fullName">
                        </div>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-xl-6">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>FTTX</mat-label>
                        <div class="search-input-container">
                            <input placeholder="Enter fibreType" id="search" matInput type="text"
                                formControlName="fibreType">
                        </div>
                    </mat-form-field>
                </div>
                <div class="col-xl-6">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Service Provider</mat-label>
                        <div class="search-input-container">
                            <input placeholder="Enter providerName" id="search" matInput type="text"
                                formControlName="providerName">
                        </div>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-xl-6">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Connected days total</mat-label>
                        <div class="search-input-container">
                            <input placeholder="Enter daysUsed" id="search" matInput type="text"
                                formControlName="daysUsed">
                        </div>
                    </mat-form-field>
                </div>
                <div class="col-xl-6">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Remaining Contract days total</mat-label>
                        <div class="search-input-container">
                            <input placeholder="Enter daysRemaining" id="search" matInput type="text"
                                formControlName="daysRemaining">
                        </div>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-4" style="color: #000000a3;">
                <div class="col-xl-6">
                    <h5>VAT Amount = {{this.terminateFee[0]?.vatAmount}} </h5>
                </div>
                <div class="col-xl-6">
                    <h5>Total Amount = {{this.terminateFee[0]?.feeWithoutVat}} + {{this.terminateFee[0]?.vatAmount}}  => <span style="font-weight:bold;"> R {{this.terminateFee[0]?.feeWithVat}}</span> </h5>
                </div>
            </div>

        </div>
    </div>
